import * as React from "react";
import Svg, { Path } from "react-native-svg";

function PhotoIcon({ width = 21, height = 19, color = "#007EFC" }) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <Path
        d="M19.3 7.556h-2.7V6.222c0-.59-.237-1.154-.659-1.571A2.265 2.265 0 0 0 14.35 4h-2.7c-.597 0-1.169.234-1.591.65A2.208 2.208 0 0 0 9.4 6.223v1.334H6.7c-.716 0-1.403.28-1.91.78A2.65 2.65 0 0 0 4 10.223v7.111c0 .708.284 1.386.79 1.886.507.5 1.194.781 1.91.781h12.6c.716 0 1.403-.281 1.91-.781.505-.5.79-1.178.79-1.886v-7.11a2.65 2.65 0 0 0-.79-1.886 2.717 2.717 0 0 0-1.91-.781Zm-8.1-1.334c0-.118.047-.23.132-.314a.453.453 0 0 1 .318-.13h2.7c.12 0 .234.047.318.13a.442.442 0 0 1 .132.314v1.334h-3.6V6.222Zm9 11.111a.883.883 0 0 1-.264.629.906.906 0 0 1-.636.26H6.7a.906.906 0 0 1-.636-.26.883.883 0 0 1-.264-.629v-7.11c0-.237.095-.463.264-.63a.906.906 0 0 1 .636-.26h12.6c.239 0 .468.094.636.26a.883.883 0 0 1 .264.63v7.11Z"
        fill={color}
      />
      <Path
        d="M13 11a3 3 0 1 0 0 5.999A3 3 0 0 0 13 11Zm0 4.286a1.285 1.285 0 1 1 0-2.571 1.285 1.285 0 0 1 0 2.57Z"
        fill={color}
      />
    </Svg>
  );
}

export default PhotoIcon;
